import React from 'react';
import { Card, Text, Title, Badge } from '@mantine/core';

interface InfoCardProps {
  title: string;
  value: string;
  description: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value, description }) => (
  <Card shadow="md" p="xl" radius="lg" withBorder className="modern-card info-card">
    <Title order={3} mb="lg" c="gray.1">{title}</Title>
    <Badge 
      size="xl" 
      radius="md" 
      mb="lg" 
      p="lg"
      variant="gradient"
      gradient={{ from: 'indigo', to: 'cyan' }}
      style={{ fontSize: '1.5rem' }}
    >
      {value}
    </Badge>
    <Text c="gray.3">{description}</Text>
  </Card>
);

export default InfoCard;